import { PortfolioPage } from './PortfolioPage';
import { createPortfolioPageHandle } from './handle';

export default {
  Component: PortfolioPage,
  createHandle: createPortfolioPageHandle
};
